export const formatCurrency = (value, maximumFractionDigits = 2) => {
    const numericValue = Number(value) || 0;

    const formattedValue = numericValue.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: maximumFractionDigits,
    });

    return formattedValue;
};
